<template>
  <v-container class="d-flex flex-column ma-2">
    <v-form lazy-validation>
      <v-text-field
        outlined
        v-model="input1.val"
        :hint="input1.hint"
        :label="input1.label"
        :rules="input1.validation"
      ></v-text-field>

      <v-text-field
        outlined
        v-model="input2.val"
        :hint="input2.hint"
        :label="input2.label"
        :rules="input2.validation"
      ></v-text-field>
      <v-text-field
        outlined
        v-model="input3.val"
        :hint="input3.hint"
        :label="input3.label"
        :rules="input3.validation"
      ></v-text-field>
      <v-text-field
        outlined
        v-model="input4.val"
        :hint="input4.hint"
        :label="input4.label"
        :rules="input4.validation"
      ></v-text-field>
      <!--      <v-text-field-->
      <!--        outlined-->
      <!--        v-model="input5.val"-->
      <!--        :hint="input5.hint"-->
      <!--        :label="input5.label"-->
      <!--        :rules="input5.validation"-->
      <!--      ></v-text-field>-->
      <v-alert
              border="bottom"
              colored-border
              type="error"
              elevation="2"
      >
        Under development. Not for use as clinical guidance.
      </v-alert>
      <v-container class="flex-row">
        <v-btn color="success" class="mr-4" @click="submit">
          Submit
        </v-btn>
        <v-btn color="error" class="mr-4" @click="reset">
          Reset
        </v-btn>
      </v-container>
    </v-form>

    <v-text-field disabled :value="output"></v-text-field>
    <v-img :src="explanationImage"></v-img>
  </v-container>
</template>

<script>
export default {
  name: "ModelInputs",
  data() {
    let rules = {
      isNumber: (x) => !isNaN(x) || "Field must be a number",
      isInRange(min, max) {
        return (v) =>
          (v >= min && v <= max) ||
          "Value must be between " + min + " and " + max;
      },
    };
    return {
      rules: rules,
      output: "",
      input1: {
        val: "",
        hint: "min_SPO2",
        label: "min_SPO2",
        validation: [rules.isNumber, rules.isInRange(0, 100000)],
      },
      input2: {
        val: "",
        hint: "FERRITIN",
        label: "FERRITIN",
        validation: [rules.isNumber, rules.isInRange(0, 100000)],
      },
      input3: {
        val: "",
        hint: "ast",
        label: "ast",
        validation: [rules.isNumber, rules.isInRange(0, 100000)],
      },
      input4: {
        val: "",
        hint: "ox_status240_ROOM_AIR",
        label: "ox_status240_ROOM_AIR",
        validation: [rules.isNumber, rules.isInRange(0, 100000)],
      },
      input5: {
        val: "",
        hint: "How many grapes",
        label: "Grapes you want",
        validation: [rules.isNumber, rules.isInRange(0, 100000)],
      },
      shap_expected: 0,
      shap_values: [],
      explanationImage: "",
    };
  },
  methods: {
    submit() {
      const v1 = parseInt(this.input1.val || "0");
      const v2 = parseInt(this.input2.val || "0");
      const v3 = parseInt(this.input3.val || "0");
      const v4 = parseInt(this.input4.val || "0");
      const v5 = parseInt(this.input5.val || "0");

      this.output = "Getting model prediction...";
      this.explanationImage=""
      const caller = this;
      this.axios
        .get("https://covidseverityindex.herokuapp.com/", {
          params: {
            p1: v1,
            p2: v2,
            p3: v3,
            p4: v4,
            p5: v5,
          },
        })
        .then(function (response) {
          caller.output = "Prediction : " + response.data.prediction;
          // caller.shap_expected=response.data.expected_value
          //caller.shap_values=response.data.shap_values
          // console.log(response);
        })
        .catch(function (error) {
          // this.output = "Sorry, an error occurred.";

          console.log(error);
        })
        .finally(function () {
          // always executed
        });
      this.draw();
    },
    reset() {
      this.input1.val = "";
      this.input2.val = "";
      this.input3.val = "";
      this.input4.val = "";
      this.input5.val = "";
      this.output = "";
      this.explanationImage = "";
      window.scrollTo(0, 0);
    },
    draw() {
      const v1 = parseInt(this.input1.val || "0");
      const v2 = parseInt(this.input2.val || "0");
      const v3 = parseInt(this.input3.val || "0");
      const v4 = parseInt(this.input4.val || "0");
      const v5 = parseInt(this.input5.val || "0");

      //this.output = "Getting model image...";
      const caller = this;
      this.axios
        .get("https://covidseverityindex.herokuapp.com/image", {
          params: {
            p1: v1,
            p2: v2,
            p3: v3,
            p4: v4,
            p5: v5,
          },
          responseType: "arraybuffer",
        })
        .then(function (response) {
          let bytes = new Uint8Array(response.data);
          let binary = bytes.reduce(
            (data, b) => (data += String.fromCharCode(b)),
            ""
          );
          caller.explanationImage = "data:image/png;base64," + btoa(binary);
          //caller.explanationImage = response.data
          //console.log(response);
        })
        .catch(function (error) {
          // this.output = "Sorry, an error occurred.";

          console.log(error);
        })
        .finally(function () {
          // always executed
        });
    },
  },
  watch: {
    explanationImage: function () {
      if (this.explanationImage !== "") {
        setTimeout(function () {
          window.scrollTo(
            0,
            document.body.scrollHeight || document.documentElement.scrollHeight
          );
        }, 200);
      }
    },
  },
};
</script>

<style scoped></style>
